var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadMain = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    fill: "#D8E6FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 25.667C39.4477 25.667 39 26.1147 39 26.667V41.2971L36.7593 38.6829C36.3998 38.2635 35.7685 38.215 35.3492 38.5744C34.9299 38.9338 34.8813 39.5651 35.2407 39.9845L39.2407 44.6511C39.4307 44.8728 39.7081 45.0003 40 45.0003C40.2919 45.0003 40.5693 44.8728 40.7593 44.6511L44.7593 39.9845C45.1187 39.5651 45.0701 38.9338 44.6508 38.5744C44.2315 38.215 43.6002 38.2635 43.2407 38.6829L41 41.2971L41 26.667C41 26.1147 40.5523 25.667 40 25.667Z",
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 36.0003V36.5047C43.9781 36.16 45.1083 36.3325 45.9523 37.0559C47.2103 38.1342 47.356 40.0281 46.2777 41.286L42.2777 45.9527C41.7078 46.6176 40.8757 47.0003 39.9999 47.0003C39.1242 47.0003 38.2921 46.6176 37.7222 45.9527L33.7222 41.286C32.6439 40.0281 32.7896 38.1342 34.0476 37.0559C34.8916 36.3325 36.0218 36.16 37 36.5047V36.0003H34.6667C30.8954 36.0003 29.0098 36.0003 27.8382 37.1719C26.6667 38.3435 26.6667 40.2291 26.6667 44.0003V45.3337C26.6667 49.1049 26.6667 50.9905 27.8382 52.1621C29.0098 53.3337 30.8954 53.3337 34.6667 53.3337H45.3333C49.1046 53.3337 50.9902 53.3337 52.1618 52.1621C53.3333 50.9905 53.3333 49.1049 53.3333 45.3337V44.0003C53.3333 40.2291 53.3333 38.3435 52.1618 37.1719C50.9902 36.0003 49.1046 36.0003 45.3333 36.0003H43Z",
    fill: "#3B82F6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadMain);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/downloadMain.36aa7e79193db34467eac2f3e8db8ad6.svg";